export default __webpack_public_path__ + "static/OvadiaImage-085d79479560a7cb48e45fca0dcd29dd.png";